<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000012" />

    <section slot="titleRight">
      <qx-permpisions permpisions="7000701">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryAccidentList"
          :params="fullSearchData"
          bizName="车辆事故信息导出"
          bizCode="exp100054"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="7000702">
        <el-button type="primary" plain @click="() => toEdit(null, '1')">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="scope.column.property === 'busiCode'"
                  @click="toBusiCodeDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    name: '查看',
                    event: () => toEdit(scope.row, '-1'),
                  },
                  {
                    permpisions: '7000703',
                    name: '修改',
                    event: () => toEdit(scope.row, '0'),
                  },
                  {
                    permpisions: '1002050501',
                    showCondition:
                      (scope.row.busiCode === '' ||
                        scope.row.busiCode === null) &&
                      scope.row.accidentState > 0 &&
                      scope.row.accidentState === 1,
                    name: '取消登记',
                    event: () => toCancel(scope.row),
                  },
                  {
                    permpisions: '1002050503',
                    showCondition:
                      (scope.row.busiCode === '' ||
                        scope.row.busiCode === null) &&
                      scope.row.accidentState > 0 &&
                      scope.row.accidentState === 2,
                    name: '取消定损',
                    event: () => toCancel(scope.row),
                  },
                  {
                    permpisions: '1002050504',
                    showCondition:
                      (scope.row.busiCode === '' ||
                        scope.row.busiCode === null) &&
                      scope.row.accidentState > 0 &&
                      scope.row.accidentState === 3,
                    name: '取消维修',
                    event: () => toCancel(scope.row),
                  },
                  {
                    permpisions: '1002050505',
                    showCondition:
                      (scope.row.busiCode === '' ||
                        scope.row.busiCode === null) &&
                      scope.row.accidentState > 0 &&
                      scope.row.accidentState === 4,
                    name: '取消核赔',
                    event: () => toCancel(scope.row),
                  },

                  {
                    permpisions: '1002050502',
                    showCondition: scope.row.accidentState === 1,
                    name: '定损',
                    event: () => toEdit(scope.row, '2'),
                  },
                  {
                    permpisions: '1002050506',
                    showCondition: scope.row.accidentState === 2,
                    name: '维修',
                    event: () => toEdit(scope.row, '3'),
                  },
                  {
                    permpisions: '1002050507',
                    showCondition:
                      scope.row.accidentState >= 2 &&
                      scope.row.accidentState < 4,
                    name: '核赔',
                    event: () => toEdit(scope.row, '4'),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryAccidentList,
  doDelVehicleAccidentInfo,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码', fixed: true },
          { prop: 'accidentStateName', label: '事故状态' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'brandModelName', label: '品牌名称' },
          { prop: 'brandModelExt', label: '品牌型号' },
          { prop: 'insuranceCompany', label: '保险公司' },
          { prop: 'insuranceUserName', label: '被保险人' },
          { prop: 'insuranceStartDate', label: '起保日期' },
          { prop: 'insuranceEndDate', label: '终保日期' },
          { prop: 'insuranceNumber', label: '保单号' },
          { prop: 'reportTime', label: '报案日期' },
          { prop: 'accidentTime', label: '出险日期' },
          { prop: 'accidentPassing', label: '出险经过' },
          { prop: 'accidentRemark', label: '出险原因' },
          { prop: 'accidentResponsibility', label: '责任归属' },
          { prop: 'isVehicleDamageName', label: '本车车损' },
          { prop: 'isOtherAccidentName', label: '对方车损' },
          { prop: 'isGoodsDamageName', label: '物损' },
          { prop: 'isRoadDamageName', label: '道路损' },
          { prop: 'isWoundingName', label: '人伤标志' },
          { prop: 'repairServiceName', label: '维修服务商' },
          { prop: 'repairServiceAddress', label: '维修地点' },
          { prop: 'repairServiceTel', label: '联系方式' },
          { prop: 'repairServiceAmt', label: '维修金额' },
          { prop: 'isRepairCompleteName', label: '维修是否完结' },
          { prop: 'settAmt', label: '核赔金额' },
          { prop: 'compensationDate', label: '核赔日期' },
          { prop: 'settAccount', label: '核赔账户' },
          { prop: 'isClosingCaseName', label: '核赔是否结案' },
          { prop: 'updateDate', label: '修改时间' },
          { prop: 'busiCode', label: '申请单号' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryAccidentList,
    toCarDetail (item) {
      if (item.licenceType < 3) {
        // 查看普通车辆详情
        const type = 'detail';
        this.jump({
          label: `查看车辆-${item.plateNumber}`,
          url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
          full: true,
        });
      } else {
        // 查看挂车详情
        this.jump({
          label: `查看挂车-${item.plateNumber}`,
          url: `/manage/car/trailer/archives/detail?id=${item.vehicleCode}&type=${''}`,
          full: true,
        });
      }
    },
    toBusiCodeDetail (item) {
      this.jump({
        label: '车辆费用',
        url: `/manage/cost/car/car?busiCode=${item.busiCode}`,
        full: true,
      });
    },
    // 取消台账
    async toCancel (item) {
      let msg = '';
      switch (item.accidentState) {
        case 1:
          msg = '取消登记';
          break;
        case 2:
          msg = '取消定损';
          break;
        case 3:
          msg = '取消维修';
          break;
        case 4:
          msg = '取消核赔';
          break;
        default:
          break;
      }
      const confirmRes = await this.$confirm(`是否确定${msg}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await doDelVehicleAccidentInfo({
          id: item.id,
          accidentState: item.accidentState,
        });
        this.getData();
      }
    },
    toEdit (item, accidentRegisterState) {
      let query = '';
      let label = '';
      switch (accidentRegisterState) {
        case '0':
          // 修改
          query = `?id=${item.id}`;
          label = '修改事故';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/edit${query}`,
            full: true,
          });
          break;
        case '1':
          // 新增
          query = '?accidentRegisterState=1';
          label = '事故登记';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/edit${query}`,
            full: true,
          });
          break;
        case '2':
          // 登记定损
          query = `?id=${item.id}&accidentRegisterState=2`;
          label = '登记定损';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/edit${query}`,
            full: true,
          });
          break;
        case '3':
          // 登记维修
          query = `?id=${item.id}&accidentRegisterState=3`;
          label = '登记维修';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/edit${query}`,
            full: true,
          });
          break;
        case '4':
          // 登记理赔
          query = `?id=${item.id}&accidentRegisterState=4`;
          label = '登记理赔';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/edit${query}`,
            full: true,
          });
          break;
        default:
          // 查看
          query = `?id=${item.id}`;
          label = '查看事故登记';
          this.jump({
            label,
            url: `/manage/car/maintain/accident/detail${query}`,
            full: true,
          });
          break;
      }
    },
    handleUpload () {
      this.$message({
        type: 'info',
        message: '开发中',
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
